import * as React from "react";
import type { SVGProps } from "react";
const SvgYoutube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.607 7.25a2.5 2.5 0 0 0-1.762-1.766c-1.566-.43-7.831-.437-7.831-.437S5.75 5.04 4.183 5.45a2.56 2.56 0 0 0-1.766 1.778C2.004 8.795 2 12.043 2 12.043s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.52 2.52 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831M10.01 15.052l.005-6 5.207 3.005z"
    />
  </svg>
);
export default SvgYoutube;
